var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"jc-section"},[_c('div',{staticClass:"jc-section-header"},[_c('h3',{staticClass:"jc-section-title"},[_vm._t("title",function(){return [_vm._v(_vm._s(_vm.title))]}),_c('small',[_vm._t("add"),_vm._t("link")],2)],2)]),_c('div',{staticClass:"jc-section-content"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }